<template>
  <main class="centerBox">
    <section class="whiteBox" style="width: 35%;">
      <div class="row logo">
        <img src="@/assets/images/logo.png" alt="logo" />
      </div>
      <div class="content">
        <h1>{{$t('forgot.title')}}</h1>
      </div>
      <hr />
      <!-- -->
      <div v-if="showFormPassword">
        <div class="content">
          <div style="padding-left:10px;padding-right:10px;padding-bottom:10px;text-align: center;">
            <label>{{$t('forgot.description')}}</label>
          </div>
          <div class="column">
            <label>{{$t('login.email')}}</label>
             <p
                class="errorSentence"
                v-if="!emailFormat && isSubmitted"
              >{{$t('error.wrongEmailFormat')}}</p>
            <input type="email" :class="{ 'error' : !emailFormat && isSubmitted }" v-model="email" />
          </div>
          <p class="tips">{{$t('forgot.forgotTips')}}</p>
        </div>
        <hr />
        <div class="content">
          <button @click="sendEmailRequest()">{{$t('button.reinitializationPassword')}}</button>
          <router-link :to="{name: 'login'}">{{$t('button.cancel')}}</router-link>
        </div>
      </div>
      <!-- -->
      <div v-if="showInformationMailSent">
        <div class="content">
          <div style="padding-left:25px;padding-right:25px;padding-bottom:25px;text-align: center;">
            <label>{{$t('forgot.emailSent')}}</label>
          </div>

          <p>{{$t('forgot.emailSent_tip1')}}</p>
          <div class="spacer-10"></div>
          <div class="spacer-10"></div>
          <p>{{$t('forgot.emailSent_tip2')}}</p>
          <div class="spacer-10"></div>
          <div class="spacer-10"></div>
          <p>{{$t('forgot.emailSent_tip3')}}</p>
        </div>
        <div v-if="showFormPassword" class="content">
          <hr />
          <button>{{$t('button.reinitializationPassword')}}</button>
          <router-link :to="{name: 'login'}">{{$t('button.cancel')}}</router-link>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import Login from "@/services/Login";
import isEmail from "validator/lib/isEmail";
export default {
  data() {
    return {
      isSubmitted: false,
      showFormPassword: true,
      showInformationMailSent: false,
      email: ""
    };
  },
  computed: {
    emailFormat: function() {
      return isEmail(this.email);
    }
  },
  mounted() {},
  methods: {
    sendEmailRequest() {
       this.isSubmitted = true;
      if(this.emailFormat){
        Login.addPasswordEmail(this.email);
       this.showFormPassword = false;
       this.showInformationMailSent = true;
      }
  
    }
  }
};
</script>
<style scoped>
.logo {
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  padding-bottom: 10%;
}
.field-icon {
  margin-left: -25px;
  z-index: 2;
}
.blue {
  color: #2e75d0;
}
.demiRowIn {
  display: "inline-flex";
  width: 50%;
  margin: 5px 0px;
}
.rowIn {
  display: "inline-flex";
  width: 100%;
  margin: 5px 0px;
}
</style>